import { Dispatch, SetStateAction } from 'react';
import { ActionDialogState } from '@/components/ActionsDialog/useActionDialog';

type UIStateAction<T> = Dispatch<SetStateAction<T>>;

export const PANEL = {
  CHECKLIST: 'checklist',
  PREFERENCES: 'preferences',
  DATA_REVIEW: 'data-review',
  FILTERS: 'filters',
  STATUSES: 'statuses',
  KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
  FILTER_TEMPLATES: 'filter-templates',
  ADD_FILTER_TEMPLATE: 'add-filter-template',
  SUPER_ADMIN_VIEW: 'super-admin-view',
  HOME: 'home',
} as const;
export type Panel = ConstType<typeof PANEL> | null;

export interface PanelHotkey {
  key: string;
  panel: Panel;
}

export type UIState = {
  openedPanel: Panel;
  setOpenedPanel: UIStateAction<Panel>;
  isFixtureInfoVisible: boolean;
  setFixtureInfoVisible: UIStateAction<boolean>;
  isDataCollectorsVisible: boolean;
  setIsDataCollectorsVisible: UIStateAction<boolean>;
  setHotkeysDisabled: UIStateAction<boolean>;
  showRowEditPopup: boolean;
  setShowRowEditPopup: UIStateAction<boolean>;
  isSlaBreachActionSelected: boolean;
  setIsSlaBreachActionSelected: UIStateAction<boolean>;
  showRowLatency: boolean;
  setShowRowLatency: UIStateAction<boolean>;
  setShowRecordAudioPopup: UIStateAction<boolean>;
  showRecordAudioPopup: boolean;
  setIsScoreboardVisible: UIStateAction<boolean>;
  isScoreboardVisible: boolean;
  assignCollection: boolean;
  setAssignCollection: UIStateAction<boolean>;
  unAssignCollection: boolean;
  setUnAssignCollection: UIStateAction<boolean>;
  goToCollection: boolean;
  setGoToCollection: UIStateAction<boolean>;
  dialogWindow: ActionDialogState;
  setDialogWindow: UIStateAction<ActionDialogState>;
};
